//  ----------      START   IMPORT  BLOCK       ----------
//  API
import APIService from '../Core/APIService';
//  Config
import API_ROUTES from '../../ConfigFiles/Routes/api_routes';
//  ----------      START   IMPORT  BLOCK       ----------


export default class AutocompleteDrugService extends APIService {
  async searchDrugs(query, signal) {
    const route = API_ROUTES.search_drugs(query);
    const test = await this.get(route, { signal });
    return test
  }
}
